// src/config/teams.js
// Canonical set of teams, used for the Third Party Tools "Team" field so admins
// pick from a fixed vocabulary instead of typing free text.

export const TEAMS = [
  'Sales',
  'Marketing',
  'Product',
  'Engineering',
  'Design',
  'Finance',
  'People',
  'Operations',
  'Data',
  'Company-wide',
];
